import { useMemo } from "react";
import { environment } from "../../../environment";
import useGetDocumentUrl from "./useGetDocumentUrl";
const s3ProxyMiddlewareUrl = (extension, action, documentUrl) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/s3/${extension}/${action}/${encodeURIComponent(documentUrl)}`
    : `https://middleware.uat.farther.com/s3/${extension}/${action}/${encodeURIComponent(documentUrl)}`;
/**
 * this hook is a successor to "useGetPdfDocument" that can operate on multiple file types not just pdfs
 */
const useGetDocumentFile = (action, filePath, config) => {
    const documentUrl = useGetDocumentUrl(filePath, config);
    return useMemo(() => {
        if (documentUrl.isLoading || documentUrl.hasError) {
            return documentUrl;
        }
        const fileExtension = filePath.split(".").at(-1);
        if (fileExtension === undefined) {
            return {
                isLoading: false,
                hasError: true,
                error: new Error(`Cannot derive the file extension from provived path: ${filePath}`),
                data: undefined,
            };
        }
        const proxiedUrl = s3ProxyMiddlewareUrl(fileExtension, action, documentUrl.data.URL);
        return { isLoading: false, hasError: false, data: proxiedUrl };
    }, [action, filePath, documentUrl]);
};
export default useGetDocumentFile;
//# sourceMappingURL=useGetDocumentFile.js.map